function buildSparsePayload(value) {
  if (value === undefined) {
    return undefined;
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    return trimmed === "" ? undefined : trimmed;
  }

  if (Array.isArray(value)) {
    const normalizedItems = value
      .map((item) => buildSparsePayload(item))
      .filter((item) => item !== undefined);

    return normalizedItems.length > 0 ? normalizedItems : undefined;
  }

  if (value && typeof value === "object") {
    const normalizedEntries = Object.entries(value)
      .map(([key, nestedValue]) => [key, buildSparsePayload(nestedValue)])
      .filter(([, nestedValue]) => nestedValue !== undefined);

    return normalizedEntries.length > 0
      ? Object.fromEntries(normalizedEntries)
      : undefined;
  }

  if (typeof value === "number" && Number.isNaN(value)) {
    return undefined;
  }

  return value;
}

function toOptionalNumber(value) {
  if (value == null || value === "") {
    return undefined;
  }

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
}

export { buildSparsePayload, toOptionalNumber };
